/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Tables_HInputs */

const en_wc_tut_tables_h = /** @type {(inputs: Wc_Tut_Tables_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4. Tables, pictures and page layout`)
};

/**
* | output |
* | --- |
* | "4. Tables, pictures and page layout" |
*
* @param {Wc_Tut_Tables_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_tables_h = /** @type {((inputs?: Wc_Tut_Tables_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Tables_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_tables_h(inputs)
});
export { wc_tut_tables_h as "wc.tut.tables.h" }